var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardItemPurpleOption(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0001 59V66.9966C67.7707 66.9988 67.7301 67 67.5001 67C30.3877 67 0.270732 37.0491 0.00195312 0H68.0001V59Z",
    fill: "#492A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3341 16.9863C45.3341 17.2929 45.2739 17.5966 45.1566 17.8799C45.0394 18.1632 44.8675 18.4206 44.6507 18.6375C44.434 18.8544 44.1767 19.0264 43.8935 19.1438C43.6102 19.2613 43.3067 19.3217 43.0001 19.3218C42.6934 19.3219 42.3898 19.2617 42.1065 19.1444C41.8232 19.0272 41.5658 18.8553 41.3489 18.6385C41.132 18.4218 40.96 18.1645 40.8426 17.8813C40.7251 17.598 40.6646 17.2944 40.6646 16.9878C40.6644 16.3686 40.9101 15.7747 41.3479 15.3367C41.7856 14.8987 42.3793 14.6525 42.9986 14.6523C43.6178 14.6521 44.2117 14.8979 44.6497 15.3356C45.0877 15.7734 45.3339 16.3671 45.3341 16.9863Z",
    fill: "#EEEEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 27.3335C44.289 27.3335 45.334 26.2886 45.334 24.9995C45.334 23.7105 44.289 22.6655 43 22.6655C41.711 22.6655 40.666 23.7105 40.666 24.9995C40.666 26.2886 41.711 27.3335 43 27.3335Z",
    fill: "#EEEEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 35.3479C44.289 35.3479 45.334 34.303 45.334 33.0139C45.334 31.7249 44.289 30.6799 43 30.6799C41.711 30.6799 40.666 31.7249 40.666 33.0139C40.666 34.303 41.711 35.3479 43 35.3479Z",
    fill: "#EEEEEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardItemPurpleOption);
export default __webpack_public_path__ + "static/media/DashboardItemPurpleOption.968558cd07f23c3d7667e4d41403e647.svg";
export { ForwardRef as ReactComponent };